import React from 'react';
import PropTypes from 'prop-types';
import './Spinner.css';
import { Typography } from '@material-ui/core';

function Spinner(props) {
    return (
        <div className="Spinner">
            <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <Typography>{props.text}</Typography>
        </div>
    );
}

Spinner.propTypes = {
    text: PropTypes.string
};

export default Spinner;




// WEBPACK FOOTER //
// ./resources/assets/js/components/Spinner.js